module.exports = __webpack_public_path__ + "static/media/c.0ae8f904.jpg";